module.exports = __webpack_public_path__ + "img/bg-grey.148e51e5.svg";